export default (node) => ({
  links: [
    {
      path: "/app/profile",
      label: "Personal Info"
    },
    {
      path: "/app/profile/company_info",
      label: "Company Info"
    },
    {
      path: "/app/profile/business_info",
      label: "Business Info"
    },
    {
      path: "/app/profile/doc_upload",
      label: "Doc Upload"
    },
    {
      path: "/app/profile/credit_rating",
      label: "Credit Rating"
    }
  ],
  creditInfo:[
    {
      type: "select",
      name: "rating_agency",
      label: "Name Of Rating Agency",
      options:enums.RatingAgency
    },
    {
      type: "text",
      name: "current_rating",
      label: "Present Rating",
    },
    {
      type: "date",
      name: "valid_till",
      label: "Rating Valid Till",
    },
    {
      type: "fileuploader",
      intype:"file",
      uploadEndpoint:"postPartnerDocument",
      deleteEndpoint:"deletePartnerDocument",
      attachname:"file",
      onFetchDocList:()=>{
        node.fetchFileList();
      },
      uploadpayload: {
        doc_meta_name:{ 
            name:`credit_rating_file`, 
            group:"profile",
            documentKey:'credit_rating' 
        }
      },
      name: "credit_rating_file",
      label: "Upload Credit Rating",
    }
  ],
  profileInfo: [
    {
      type: "text",
      name: "user_name",
      label: "Name",
      required: true,
      "data-visible":(node.profileInfo?.visible??{})['user_name']??true,
      readOnly:(node.profileInfo?.disabled??{})['user_name']??false
    },
    {
      type: "text",
      name: "user_id",
      label: "User ID",
      required: true,
      "data-visible":(node.profileInfo?.visible??{})['user_id']??true,
      readOnly:(node.profileInfo?.disabled??{})['user_id']??false
    },
    {
      type: "number",
      name: "contact_number",
      label: "Mobile Number",
      required: true,
      "data-visible":(node.profileInfo?.visible??{})['contact_number']??true,
      readOnly:(node.profileInfo?.disabled??{})['contact_number']??false
    },
    {
      type: "email",
      name: "email_address",
      "data-visible":(node.profileInfo?.visible??{})['email_address']??true,
      readOnly:(node.profileInfo?.disabled??{})['email_address']??false,
      label: "Email ID",
      required: true,
    },
    // {
    //   type: "date",
    //   name: "date_of_birth",
    //   "data-visible":(node.profileInfo?.visible??{})['date_of_birth']??true,
    //   readOnly:(node.profileInfo?.disabled??{})['date_of_birth']??false,
    //   label: "Date Of Birth",
    //   onChange:(date)=>{
    //     let age = document.querySelector("input[name='age']");
    //     age.value = date.getAge();
    //     console.log("Date Changed",date,node.profileInfo);
    //   }
    // },
    // {
    //   type: "number",
    //   name: "age",
    //   "data-visible":(node.profileInfo?.visible??{})['age']??true,
    //   readOnly:(node.profileInfo?.disabled??{})['age']??false,
    //   label: "Age",
    //   min:18,
    //   max:108
    // },
    // {
    //   type: "select",
    //   name: "gender",
    //   "data-visible":(node.profileInfo?.visible??{})['gender']??true,
    //   readOnly:(node.profileInfo?.disabled??{})['gender']??false,
    //   label: "Gender",
    //   options: ['M', 'F'].options("","",(v)=>(v=='M'?'Male':'Female'))
    // },
    {
      type: "select",
      name: "state",
      "data-visible":(node.profileInfo?.visible??{})['state']??true,
      readOnly:(node.profileInfo?.disabled??{})['state']??false,
      label: "State",
      options: Object.keys(statecity).options(),
      onData(value) {
        console.log({onData:value});
        let city = node.state.fields.profileInfo.find(o=>o.name=='city');
        city.options = Object.assign(city.options,statecity[value].options());
      },
      onChange([value],config={}) {
        let city = node.state.fields.profileInfo.find(o=>o.name=='city');
        if(city&&statecity[value.key]) {
          city.options = Object.assign(city.options,statecity[value.key].options());
        }
      }
    },
    {
      type: "select",
      name: "city",
      "data-visible":(node.profileInfo?.visible??{})['city']??true,
      readOnly:(node.profileInfo?.disabled??{})['city']??false,
      label: "City",
      options: []
    },
  ],
  companyInfo: [
    {
      name: "company_name",
      "data-visible":(node.companyInfo?.visible??{})['company_name']??true,
      disabled:(node.companyInfo?.disabled??{})['company_name']??false,
      label: "Entity Name",
    },
    {
      name: "company_type",
      "data-visible":(node.companyInfo?.visible??{})['company_type']??true,
      disabled:(node.companyInfo?.disabled??{})['company_type']??false,
      label: "Entity Type",
      type: "select",
      options: enums.industry,
      onChange:([value])=>{
        let companyInfo = node.state.fields.companyInfo;
        let num_of_directors = companyInfo.find(o=>o.name=='num_of_directors');
        num_of_directors.label = "No. of Partners";
        num_of_directors.visible = true;
        switch(value.key) {
          case "ppc":
            num_of_directors.label = "No. Of Directors";
            console.log({companyInfo});
            node.setState((state)=>({
              fields:{
                ...state.fields,
                companyInfo: [
                  ...companyInfo
                ]
              }
            }))
          break;
          case "indv":
          case "prop":
            num_of_directors.visible = false;
          break;
        }
        node.setState((state)=>({
          fields:{
            ...state.fields,
            companyInfo: [
              ...companyInfo
            ]
          }
        }))
      }
    },
    {
      name: "industry_type",
      "data-visible":(node.companyInfo?.visible??{})['industry_type']??true,
      disabled:(node.companyInfo?.disabled??{})['industry_type']??false,
      label: "Industry",
      type: "text",
      options: [],
    },
    {
      name: "annual_turnover",
      "data-visible":(node.companyInfo?.visible??{})['annual_turnover']??true,
      disabled:(node.companyInfo?.disabled??{})['annual_turnover']??false,
      label: "Annual Turnover",
      type: "select",
      options: enums.turnOver.options(),
    },
    {
      name: "registration_id",
      "data-visible":(node.companyInfo?.visible??{})['registration_id']??true,
      disabled:(node.companyInfo?.disabled??{})['registration_id']??false,
      label: "CIN ID",
      type: "text",
    },
    {
      name: "num_of_directors",
      "data-visible":(node.companyInfo?.visible??{})['num_of_directors']??true,
      readOnly:(node.companyInfo?.disabled??{})['num_of_directors']??false,
      label: "No. of Partners",
      type: "number",
      min:1,
      max:10
    },
    {
      name: "pan_id",
      "data-visible":(node.companyInfo?.visible??{})['pan_id']??true,
      disabled:(node.companyInfo?.disabled??{})['pan_id']??false,
      label: "PAN",
      type: "text",
      required: true,
    },
    {
      name: "tan_id",
      "data-visible":(node.companyInfo?.visible??{})['tan_id']??true,
      disabled:(node.companyInfo?.disabled??{})['tan_id']??false,
      label: "TAN",
      type: "text",
      required: true,
    },
    {
      name: "gstin_id",
      "data-visible":(node.companyInfo?.visible??{})['gstin_id']??true,
      disabled:(node.companyInfo?.disabled??{})['gstin_id']??false,
      label: "GSTIN",
      type: "text",
      required: true,
    },
    // {
    //   name: "company_address",
    //   "data-visible":(node.companyInfo?.visible??{})['company_address']??true,
    //   disabled:(node.companyInfo?.disabled??{})['company_address']??false,
    //   label: "Door number, Building area, Street",
    //   type: "text",
    //   required: true,
    // },
    {
      name: "gst_count",
      "data-visible":(node.companyInfo?.visible??{})['company_address']??true,
      disabled:(node.companyInfo?.disabled??{})['company_address']??false,
      label: "Number Of GST Registration",
      type: "text",
      required: true,
    },
    {
      type: "select",
      name: "company_state",
      "data-visible":(node.companyInfo?.visible??{})['company_state']??true,
      disabled:(node.companyInfo?.disabled??{})['company_state']??false,
      label: "State",
      options: Object.keys(statecity).options(),
      onData(value) {
        let companyCity = node.state.fields.companyInfo.find(o=>o.name=='company_city');
        companyCity.options = Object.assign(companyCity.options,statecity[value].options());
      },
      onChange([value]) {
        let companyCity = node.state.fields.companyInfo.find(o=>o.name=='company_city');
        companyCity.options = Object.assign(companyCity.options,statecity[value.key].options());
      }
    },
    {
      type: "select",
      name: "company_city",
      "data-visible":(node.companyInfo?.visible??{})['company_city']??true,
      disabled:(node.companyInfo?.disabled??{})['company_city']??false,
      label: "City",
      options: []
    },
  ],
  businessInfo: [
    {
      name: "snum",
      "data-visible":(node.visible??{})['snum']??true,
      disabled:(node.disabled??{})['snum']??false,
      label: "Serial No.",
      type: "number",
      required: true,
      disabled:true
    },
    {
      name: "director_name",
      "data-visible":(node.visible??{})['director_name']??true,
      disabled:(node.disabled??{})['director_name']??false,
      label: "Partner's Name",
      type: "text",
      required: true,
    },
    {
      name: "din_num",
      "data-visible":(node.visible??{})['din_num']??true,
      disabled:(node.disabled??{})['din_num']??false,
      label: "DPIN/DIN",
      type: "text",
      required: true,
    },
    {
      name: "effective_from",
      "data-visible":(node.visible??{})['effective_from']??true,
      disabled:(node.disabled??{})['effective_from']??false,
      label: "As On",
      type: "date",
      required: true
    },
    {
      name: "share_holding_pc",
      "data-visible":(node.visible??{})['share_holding_pc']??true,
      disabled:(node.disabled??{})['share_holding_pc']??false,
      label: "Share holding %",
      type: "number",
      required: true,
    }
  ],
  docInfo: [
    {
      name: "snum",
      "data-visible":(node.visible??{})['snum']??true,
      disabled:(node.disabled??{})['snum']??true,
      label: "Serial No.",
      type: "number",
      required: true,
    },
    {
      name: "director_name",
      "data-visible":(node.visible??{})['partnersName']??true,
      disabled:(node.disabled??{})['partnersName']??true,
      label: "Partner's Name",
      type: "text",
      required: true,
    },
    {
      name: "aadharcard",
      "data-director_id":"0",
      "data-doctype":"AADHAR",
      "data-visible":(node.visible??{})['aadharcard']??true,
      disabled:(node.disabled??{})['aadharcard']??false,
      label: "Aadhar Card",
      type: "file",
      required: true,
      editaccess: "true"
    },
    {
      name: "pancard",
      "data-director_id":"0",
      "data-doctype":"PAN",
      "data-visible":(node.visible??{})['pancard']??true,
      disabled:(node.disabled??{})['pancard']??false,
      label: "Pan Card",
      type: "file",
      required: true,
      editaccess: "true"
    },
  ]
})